import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeLeaveStatementsReport extends Layout {
    OfficeLeaveStatementsReportDatasource: DataSource;
    checkboxEmailStatements: Checkbox;
    checkboxPageBreakPayee: Checkbox;
    checkboxPrintBannerPage: Checkbox;
    excludabletextboxDivisionId: ExcludableTextbox;
    excludabletextboxPayeeId: ExcludableTextbox;
    excludabletextboxTerminalId: ExcludableTextbox;
    textboxDateType: Textbox;
    textboxOfficeLeaveStatementsCheckDate: Textbox;
}
